// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Label = require("../../common/Components/Label.bs.js");
let Scalars = require("../../../scalars/Scalars.bs.js");
let UTCDate = require("../../../reason/common/types/UTCDate.bs.js");
let DateFns = require("date-fns");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let SharedPostEmailStatsSingleRecipient_recipient_graphql = require("../../../__generated__/SharedPostEmailStatsSingleRecipient_recipient_graphql.bs.js");

let convertFragment = SharedPostEmailStatsSingleRecipient_recipient_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, SharedPostEmailStatsSingleRecipient_recipient_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(SharedPostEmailStatsSingleRecipient_recipient_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, SharedPostEmailStatsSingleRecipient_recipient_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(SharedPostEmailStatsSingleRecipient_recipient_graphql.node, convertFragment, fRef);
}

let RecipientFragment_sharedPropertyEmailStatsForRecipientEmailStatus_decode = SharedPostEmailStatsSingleRecipient_recipient_graphql.Utils.sharedPropertyEmailStatsForRecipientEmailStatus_decode;

let RecipientFragment_sharedPropertyEmailStatsForRecipientEmailStatus_fromString = SharedPostEmailStatsSingleRecipient_recipient_graphql.Utils.sharedPropertyEmailStatsForRecipientEmailStatus_fromString;

let RecipientFragment = {
  sharedPropertyEmailStatsForRecipientEmailStatus_decode: RecipientFragment_sharedPropertyEmailStatsForRecipientEmailStatus_decode,
  sharedPropertyEmailStatsForRecipientEmailStatus_fromString: RecipientFragment_sharedPropertyEmailStatsForRecipientEmailStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function SharedPostEmailStatsSingleRecipient$StatusLabel(props) {
  let status = props.status;
  if (status !== undefined && (status === "CLICKED" || status === "DELIVERED")) {
    if (status === "CLICKED") {
      return JsxRuntime.jsx(Label.Positive.make, {
        text: "Clicked"
      });
    } else {
      return JsxRuntime.jsx(Label.Info.make, {
        text: "Delivered"
      });
    }
  } else {
    return JsxRuntime.jsx(Label.Neutral.make, {
      text: "Undelivered"
    });
  }
}

let StatusLabel = {
  make: SharedPostEmailStatsSingleRecipient$StatusLabel
};

function SharedPostEmailStatsSingleRecipient(props) {
  let recipient = RescriptRelay_Fragment.useFragment(SharedPostEmailStatsSingleRecipient_recipient_graphql.node, convertFragment, props.recipient);
  let match = recipient.contact;
  let email;
  if (match !== undefined) {
    let exit = 0;
    switch (match.__typename) {
      case "SharingContactClientContactV5" :
      case "SharingContactFreshContactV5" :
        exit = 1;
        break;
      case "__unselected" :
        email = "-";
        break;
    }
    if (exit === 1) {
      let email$1 = match.email;
      email = email$1 !== undefined ? Scalars.EmailAddress.toString(Primitive_option.valFromOption(email$1)) : "-";
    }
  } else {
    email = "-";
  }
  let opens = Stdlib_Option.getOr(recipient.numberOfClicks, 0).toString();
  let dt = recipient.lastClickedAt;
  let lastClicked = dt !== undefined ? DateFns.formatDistance(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(Primitive_option.valFromOption(dt))), new Date()) + " ago" : "-";
  return JsxRuntime.jsx("li", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: email,
              className: "truncate"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(SharedPostEmailStatsSingleRecipient$StatusLabel, {
                status: recipient.status
              }),
              className: "text-right"
            }),
            JsxRuntime.jsx("div", {
              children: opens,
              className: "text-right"
            }),
            JsxRuntime.jsx("div", {
              children: lastClicked,
              className: "text-right"
            })
          ],
          className: "hidden md:grid md:grid-cols-4 md:items-center md:gap-4"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: email,
              className: "font-medium truncate"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("span", {
                      children: "Status",
                      className: "text-gray-500"
                    }),
                    JsxRuntime.jsx("span", {
                      children: JsxRuntime.jsx(SharedPostEmailStatsSingleRecipient$StatusLabel, {
                        status: recipient.status
                      })
                    })
                  ],
                  className: "flex items-center justify-between gap-3"
                }),
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("span", {
                      children: "Clicks",
                      className: "text-gray-500"
                    }),
                    JsxRuntime.jsx("span", {
                      children: opens,
                      className: "text-gray-900"
                    })
                  ],
                  className: "flex items-center justify-between gap-3"
                }),
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("span", {
                      children: "Last clicked",
                      className: "text-gray-500"
                    }),
                    JsxRuntime.jsx("span", {
                      children: lastClicked,
                      className: "text-gray-900 truncate"
                    })
                  ],
                  className: "flex items-center justify-between gap-3"
                })
              ],
              className: "flex flex-col gap-2 text-sm"
            })
          ],
          className: "md:hidden flex flex-col gap-2"
        })
      ],
      className: "p-4"
    }),
    className: "even:bg-gray-50"
  });
}

let make = SharedPostEmailStatsSingleRecipient;

exports.RecipientFragment = RecipientFragment;
exports.StatusLabel = StatusLabel;
exports.make = make;
/* Label Not a pure module */
